import { render } from "./InventoryLogs.vue?vue&type=template&id=41a5e4c6&ts=true"
import script from "./InventoryLogs.vue?vue&type=script&lang=ts"
export * from "./InventoryLogs.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__